export class User {
    constructor(public data: {
        ID?: Number,
        AgentCode?: String,
        Firstname?: String,
        Lastname?: String,
        Email?: String,
        Mobile?: String,
        Username?: String,
        Password?: String,
        ConfirmPassword?: String,
        UserType?: String,
        Active?: Boolean,
        AgentMustSign?: Boolean,
        EmploymentStarted?: String,
        EmploymentEnded?: String,
        UsersBranchOffices?: Array<{ BranchOfficeID?: Number, UserID?: Number }>,
        AgentSNOCode?: String
    }) { }
}